import { render, staticRenderFns } from "./CopyLink.vue?vue&type=template&id=8bae4fee&"
import script from "./CopyLink.vue?vue&type=script&lang=ts&"
export * from "./CopyLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports